import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableListViewComponent } from '../../table-list-view/table-list-view.component';
import { EntityType } from '../../shared/share';
import { MatFormField } from "@angular/material/form-field";
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { AddApplicantComponent } from '../add-applicant/add-applicant.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';
import { MemberInsurerRestService } from '@app/modules/lps-member-login/services/member-insurer-rest.service';
import { Location } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { ViewModeToggleComponent } from "../../shared/components/view-mode-toggle/view-mode-toggle.component";
import { TableCardViewComponent } from "../../table-card-view/table-card-view.component";
import { PatientProfileComponent } from '../../patient-profile/patient-profile.component';
import { DialogConfig } from '@angular/cdk/dialog';
import { RequestMedicalEvidenceComponent } from '../../request-medical-evidence/request-medical-evidence.component';
import { LoaderComponent } from "../../shared/loader/loader.component";

@Component({
  selector: 'app-all-applicants',
  standalone: true,
  imports: [CommonModule, TableListViewComponent, MatFormField, FormsModule, MatInputModule, ViewModeToggleComponent, TableCardViewComponent, LoaderComponent],
  templateUrl: './all-applicants.component.html',
  styleUrl: './all-applicants.component.scss'
})
export class AllApplicantsComponent implements OnInit {
  openRequestMe(row: any) {
    const merow = row;
    console.log(merow);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(RequestMedicalEvidenceComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });

  }
  openEditForm(row: any) {
    const editdata = row;
    console.log(editdata);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '800px';
    dialogConfig.height = '600px';
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(AddApplicantComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        console.log(confirm)

      }
    });



  }
  selectedPatient: any;
  openpatientprofile(row: any) {
    this.selectedPatient = row;
    console.log(this.selectedPatient)
    this.memberService.setSelectedPatient(row);
    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '800px';
    dialogConfig.height = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.enterAnimationDuration = 200;
    dialogConfig.data = row;
    const dialogRef = this.dialog.open(PatientProfileComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {

      }
    });
  }

  applicantsData: any[] = []

  applicantsDataTemp: any[] = [];
  viewMode: 'list' | 'grid' = 'list';
  enumRole: any;

  changeViewMode(mode: 'list' | 'grid') {
    this.viewMode = mode;
  }

  constructor(private location: Location, private dialog: MatDialog, private memberService: MemberInsurerServiceService, private restservice: MemberInsurerRestService) { }
  isSidebarExpanded: boolean = false;
  cardSelected: any;
  patientIdSelected: any;
  dataSource = new MatTableDataSource<any>([]);

  ngOnInit() {

    this.enumRole=this.memberService.getLoginUserRole();
    this.viewMode='list';
    console.log(this.viewMode)
    this.enumRole = this.memberService.getLoginUserRole();
    console.log(this.enumRole)
    this.getallDistributorPatients();
    this.memberService.sidebarExpanded$.subscribe((expanded) => {
      console.log('Sidebar expanded state:', expanded);
      if (expanded) {
        this.isSidebarExpanded = false;
      } else {
        this.isSidebarExpanded = true;
      }
    });

    const state: any = this.location.getState();
    const index = state?.index;

    const patientId = state?.id;
    this.patientIdSelected = patientId;

    const statusList = ['DRAFTED', 'SUBMITTED'];
    this.cardSelected = statusList[index] || null;
  }

  applyPatientFilter() {
    if (this.cardSelected) {
      this.applicantsData = this.applicantsDataTemp.filter(x => x.status === this.cardSelected);
    } else if (this.patientIdSelected) {
      this.applicantsData = this.applicantsDataTemp.filter(x => x.firstName === this.patientIdSelected);
    } else {
      this.applicantsData = [...this.applicantsDataTemp]; // clone for safety
    }
    // Update data source for UI
    this.dataSource.data = this.applicantsData;
  }

  clearFilters() {
    this.cardSelected = undefined;
    this.patientIdSelected = undefined;
    this.applyPatientFilter();  // will reset patientsList and update dataSource
  }

  isDataLoading: boolean = false;

  getallDistributorPatients() {
    this.isDataLoading = true;
    const id = this.memberService.getLoginUserId();
    this.restservice.getDistributorApplicants(id).subscribe({
      next: (value) => {
        console.log(value);
        this.applicantsDataTemp = value;
        this.applicantsData = this.applicantsDataTemp;
        this.viewMode='list';
        this.isDataLoading = false;
        if (this.cardSelected || this.patientIdSelected) {
          this.applyPatientFilter();
        }
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  tableSource = 'ALL_APPLICANTS';

  displayedColumns: string[] = ['applicantName', 'email', 'phone', 'applicationDate', 'policyType', 'gender', 'status', 'actions'];
  columnDisplayNames: string[] = ['Applicant', 'Email', 'Contact Number', 'Application Date', 'Gender', 'Status', 'Actions'];

  // Entity type for table-list-view component
  enumEntityType = EntityType;

  isRotating = false;
  searchQuery: string = '';


  onRefresh() {
    this.isRotating = true;
    // this.getMemberList();
    this.getallDistributorPatients()
    // Stop animation after 1s (match CSS animation duration)
    setTimeout(() => {
      this.isRotating = false;
    }, 500);
  }
  searchExpanded = false;

  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (!this.searchExpanded) {
      this.searchQuery = '';
      this.onSearch(); // reset search on close
    }
  }

  onSearch() {
    console.log("search started")
    const querey = this.searchQuery.trim().toLowerCase();
    if (!querey) {
      this.applicantsData = this.applicantsDataTemp;
      console.log(querey)
    }
    console.log(querey)
    this.applicantsData = this.applicantsData.filter(row =>
      Object.values(row).some(val =>
        val && val.toString().toLowerCase().includes(querey)
      )
    );


  }

  onAddApplicant() {

    const dialogConfig = new MatDialogConfig()
    dialogConfig.width = '1150px';
    dialogConfig.height = '700px';
    // dialogConfig.data=
    this.dialog.open(AddApplicantComponent, dialogConfig)
  }
}
